export default __webpack_public_path__ + "static/media/no-result.c788c571.svg";